import { Button } from '@mui/material';

import { InvoiceSummaryDto } from 'src/generated/services/TFinancialApi';
import Modal from 'src/presentations/components/molecules/modal';
import { ActivityLogModalContent } from './ActivityLogModalContent';

interface IModalProps {
  invoiceSummary: InvoiceSummaryDto;
  open: boolean;
  onClose: () => void;
}

const ActivityLogModal: React.FC<IModalProps> = (props) => {
  const { invoiceSummary, open, onClose } = props;

  return (
    <Modal open={open} onClose={onClose} title='Activity Log' fullWidth maxWidth='sm'>
      <div className='pt-12'>
        <ActivityLogModalContent invoiceSummary={invoiceSummary} />
        <div className='mt-48'>
          <Button variant='contained' color='primary' fullWidth onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ActivityLogModal;
